(function ($, Global) {
    var urlParams = new UrlParams();

    function GratuitPage() {
        // Déclaration class objet
    }

    GratuitPage.prototype.initEvents = function () {
        this.publishers();
    };

    GratuitPage.prototype.publishers = function () {
        $(document).ready(function () {
            if (urlParams.getParam('edition') === '1') {
                if (!$('.sidenav .sidebloc-download-free-edition').exists()) return;
                var linkEditionPdf = $('.sidenav .sidebloc-download-free-edition').find('a').attr('href');

                Global.location.replace(linkEditionPdf)
            }
        });
        $(document).on('click', '.sidebloc-download-free-edition .btn-block', function () {
            var $this = $(this);
            var publication = $('.sidebloc-download-free-edition select').val();
            var url = $this.data('download-pdf');

            url = url.slice(0, url.lastIndexOf('/'));

            if (!url || publication === '') return;

            Global.location.replace(url + '/' + publication);
        });
    };

    Global.GratuitPage = GratuitPage;
}(jQuery, window));